import React from 'react';
import HoverTooltip from './hoverTooltip';
import Constants from '../../../../definitions/constants';

const FormSection = props => {
  const {
    labelLocale,
    marginTop,
    toolTipContent,
    className
  } = props;  

  return(
    <div className={"form_section_label_wrapper" + (className ? (" " + className) : "")} style={{marginTop: marginTop}}>
      <div className={("form_section_label_text") + (toolTipContent ? " form_section_has_tooltip" : "")} >
          {props.labelLocale}
      </div>
      <div className="form_section_label"></div>
      {(toolTipContent) && (
        <HoverTooltip 
          toolTip={toolTipContent}
          toolTipType={Constants.interface.toolTip.formSectionHelp}
          placement="right-end" 
          enterDelay={300} 
          leaveDelay={100}
          classes={{popper: "form_section_tooltip", tooltip: "form_section_tooltip_inner"}}
        >
          <div className="form_section_label_tooltip_icon">
            <i 
              className="fas fa-question-circle"
            />
          </div>
        </HoverTooltip>
      )}
    </div>
  )
};

export default FormSection;



// WEBPACK FOOTER //
// ./source/client/components/common/interface/formSection.jsx